export const pulseSteps = [
    {
        'id': 'idiomas',
        'title'  : 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
        'videoBanner': 'idiomas',
        'icon' : 'language',
        'ruta' : './languages',
        'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP1.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP1.SUBTI',
        'status' : 1,
        visible: true
    },
    // {
    //     'id': 'forall',
    //     'title'  : 'WIZARD.CERTIFICAR.STEPS.STP2.WIZBT',
    //     'videoBanner': 'forall',
    //     'icon' : 'format_list_numbered',
    //     'ruta' : './ForAll',
    //     'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP2.TITULO',
    //     'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP2.SUBTI',
    //     'status' : 1
    // },
    // {
    //     'id': 'demo',
    //     'title'  : 'WIZARD.CERTIFICAR.STEPS.STP3.WIZBT',
    //     'videoBanner': 'demograficos',
    //     'icon' : 'poll',
    //     'ruta' : './demographics',
    //     'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP3.TITULO',
    //     'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP3.SUBTI',
    //     'status' : 1
    // },
    // {
    //     'id': 'adic',
    //     'title'  : 'WIZARD.CERTIFICAR.STEPS.STP4.WIZBT',
    //     'videoBanner': 'adicionales',
    //     'icon' : 'note_add',
    //     'ruta' : './additionals',
    //     'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP4.TITULO',
    //     'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP4.SUBTI',
    //     'status' : 1
    // },
    {
        'id': 'colabs',
        'title'  : 'WIZARD.CERTIFICAR.STEPS.STP5.WIZBT',
        'videoBanner': 'colaboradores',
        'icon' : 'people',
        'ruta' : './collaborators',
        'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP5.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP5.SUBTI',
        'status' : 1,
        visible: true
    },
    {
        'id': 'prog',
        'title'  : 'WIZARD.CERTIFICAR.STEPS.STP6.WIZBT',
        'videoBanner': 'programar',
        'icon' : 'date_range',
        'ruta' : './schedule',
        'tituloPagina': 'WIZARD.PULSE.STEPS.STP6.TITULO',
        'subtiPagina': 'WIZARD.PULSE.STEPS.STP6.SUBTI',
        'status' : 1,
        visible: true
    },
    {
        'id': 'envio',
        'title'  : 'WIZARD.CERTIFICAR.STEPS.STP7.WIZBT',
        'videoBanner': 'envio',
        'icon' : 'send',
        'ruta' : './mailSending',
        'tituloPagina': 'WIZARD.CERTIFICAR.STEPS.STP7.TITULO',
        'subtiPagina': 'WIZARD.CERTIFICAR.STEPS.STP7.SUBTI',
        'status' : 1,
        visible: true
    },
    {
        id: 'confirmacion',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP9.WIZBT',
        videoBanner: '',
        icon : 'build_circle',
        ruta : './statusSurveys',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP9.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP9.SUBTI',
        status : 1,
        visible: true
    },
    {
        'id': 'cierre',
        'title'  : 'WIZARD.CERTIFICAR.STEPS.STP8.WIZBT',
        'videoBanner': 'cierre',
        'icon' : 'power_settings_new',
        'ruta' : './close',
        'tituloPagina': 'WIZARD.PULSE.STEPS.STP8.TITULO',
        'subtiPagina': 'WIZARD.PULSE.STEPS.STP8.SUBTI',
        'status' : 1,
        visible: true
    }
];
